import React, { useContext, useState } from "react";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { AuthContext } from "../../context/auth/AuthContext";
import { Request } from "../../api/eklok/Eklok.api";
import Success from "../../components/Success";

const EditEklokContainer = ({ eklok, children }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);
  const [success, setSuccess] = useState(false);

  const onSubmit = (values, actions) => {
    setError(null);
    setLoading(true);
    Request.updateEklok(token.access, { ...values, eklok: eklok.id })
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = ({ data }, actions) => {
    actions.setSubmitting(false);
    setLoading(false);
    setSuccess(true);
  };

  const onFailure = (error, actions) => {
    setError(error);
    setLoading(false);
    actions.setSubmitting(false);
  };

  const onCloseSuccesPopup = () => {
    setSuccess(null);
  };
  return (
    <>
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {loading ? <Loading /> : null}
      {success ? (
        <Success
          message="Eklok data has been updated."
          onClose={() => onCloseSuccesPopup()}
        />
      ) : null}
      {children({ onSubmit, eklok })}
    </>
  );
};

export default EditEklokContainer;
